import type { RxJsonSchema } from 'rxdb';
import type { RemedialAction } from './remedialAction.types';

export const remedialActionSchema: RxJsonSchema<RemedialAction> = {
  type: 'object',
  version: 0,
  description: 'describes deficiency lists',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    name: { type: ['string', 'null'] },
    discipline: { type: ['number', 'null'] },
    sort: { type: ['number', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    dateModified: { type: ['string', 'null'] },
  },
};
